import { ISpecificationCategoryModel } from '../../../../../../service/specification/category/ISpecificationCategoryModel';
import { ISpecificationEntityModel } from '../../../../../../service/specification/entity/ISpecificationEntityModel';
import { ComplexMultiselectDomain } from '../../../form/store/ComplexMultiselectDomain';

export class SpecificationFormSelectionDomain extends ComplexMultiselectDomain {
  specificationCategoriesValues = (specifications: ISpecificationEntityModel[], categoryId?: string) => {
    return specifications
      .filter((entity) => entity.categoryId === categoryId)
      .map((entity) => ({
        value: entity.id || '',
        name: entity.isActive ? entity.name : `${entity.name} (неактивен)`,
      }));
  };

  onLoad({
    selectedSpecificationsIds,
    specifications,
    specificationCategories
  }: {
    selectedSpecificationsIds: string[];
    specificationCategories: ISpecificationCategoryModel[];
    specifications: ISpecificationEntityModel[];
  }) {
    const expectedData: { [categoryId: string]: string[] } = {};

    specificationCategories.forEach((category) => {
      const categoryId = category.id;

      const categoryValues = specifications.filter(
        (spec) => spec.categoryId === categoryId
      ).map(spec => spec.id);

      const selectedForThisCategory = selectedSpecificationsIds.filter((id) =>
        categoryValues.includes(id)
      );

      if (selectedForThisCategory.length > 0 && categoryId) {
        expectedData[categoryId] = selectedForThisCategory;
      }
    });
    for (let categoryId in expectedData) {
      this.complexMultiSelectData[categoryId] = expectedData[categoryId];
    }

    for (let categoryId in this.complexMultiSelectData) {
      if (!expectedData[categoryId]) {
        const categoryValues = specifications.filter(
          (spec) => spec.categoryId === categoryId
        ).map(spec => spec.id);

        const stillSelected = selectedSpecificationsIds.filter((id) =>
          categoryValues.includes(id)
        );

        if (stillSelected.length === 0) {
          delete this.complexMultiSelectData[categoryId];
        }
      }
    }
  }
}
